import { useTranslation } from 'react-i18next';

import { Tab } from '../Tab';

import { AdditionalForm } from './components/AdditionalForm';
import { CredentialsForm } from './components/CredentialsForm';
import IntegrationGuide from './components/IntegrationGuide';

export function Shopify() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.Shopify',
  });

  return (
    <Tab title={t('title')} description={t('description')}>
      <IntegrationGuide />
      <CredentialsForm />
      <AdditionalForm />
    </Tab>
  );
}
